import { Component, Input, OnInit, AfterViewInit } from "@angular/core";
import { ModalController } from "@ionic/angular";
import * as _ from "lodash";
@Component({
  selector: "kreform-field-ion-tags",
  template: `
    <div [innerHtml]="content | safeHtml"></div>
  `
})
export class KreFormFieldIonTagsComponent implements OnInit, AfterViewInit {
  @Input() content: string;

  constructor(public modalController: ModalController) {}

  ngOnInit() {}

  ngAfterViewInit() {}
}
